// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_3CVuO___modal-module__overlay","container":"_1vmJ4___modal-module__container","close":"_1U-sC___modal-module__close"};